<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { HTMLDialogAttributes } from 'svelte/elements';
  import X from "~icons/ph/x"

  type Props = HTMLDialogAttributes & {
    children: Snippet;
    class?: string;
    autoOpen?: boolean;
    showClose?: boolean;
    autofocus?: boolean;
    animate?: boolean;
    position?: "auto" | "middle" | "bottom";
  };

  let {
    children,
    class: className,
    autoOpen,
    showClose, // If true and you don't set autofocus on or inside dialog, the close button will be autofocused
    autofocus, // Set true if you do not want the the close button focused and there's nothing inside the dialog that should get initial focus
    animate = true, // Transitions can sometimes produce undesirable artefacts inside nested dialogs
    position = "auto",
    ...props
  } : Props = $props()
  let dialog = $state<HTMLDialogElement>()

  export function close(v = undefined){
    return dialog?.close(v)
  }

  export function isOpen(){
    return !!dialog?.open
  }

  export function showModal(){
    return dialog?.showModal()
  }
</script>

<!-- svelte-ignore a11y_autofocus -->
<dialog bind:this={dialog} {autofocus} data-auto-open={autoOpen || null}
  class="modal"
  class:modal-bottom={position == "auto" || position == "bottom"}
  class:sm:modal-middle={position == "auto"}
  class:modal-middle={position == "middle"}
  class:transition-none={!animate}
  {...props}
>

  <div class="modal-box overscroll-contain {className}">
    {#if showClose}
      <div class="sticky right-0 top-0 will-change-transform" aria-hidden="true">
        <X class="btn-ghost btn-circle -right-4 -top-4 absolute h-8 w-8 p-1 m-2" role="button" onclick={() => close()}></X>
      </div>
    {/if}
    {@render children()}
    {#if showClose}
      <form method="dialog" class="sr-only"><button>close</button></form>
    {/if}
  </div>
</dialog>
